import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import logo from "../../assets/logo/logo-only.webp";
import { FaFacebook, FaInstagram, FaTiktok } from "react-icons/fa";

const Footer = () => {
  const scrollFooter = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  return (
    <footer className="footer-wrapper">
      <div className="footer-container">
        <div className="row">
          <div className="col-12 col-sm-6 col-lg-4">
            <div className="logo">
              <Link to="/" onClick={() => scrollFooter()}>
                <img src={logo} alt="logo" />
              </Link>
            </div>
            <p>
              <strong className="text-white">
                Educraft Education Network{" "}
              </strong>
              is a trusted education consultancy dedicated to helping students
              achieve their dream of studying abroad. With a team of expert
              counselors and a vast network of international universities, we
              provide personalized guidance and end-to-end support to make
              overseas education a seamless experience.
            </p>
            <div className="icons-container">
              <a
                href="https://www.facebook.com/profile.php?id=100088829740129"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.instagram.com/educrafteducation?igsh=c296Z2k0dzVtZHNv"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.tiktok.com/@educraft.education"
                target="_blank"
                rel="noreferrer"
              >
                <FaTiktok />
              </a>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-2">
            <h1 className="title">Routes</h1>
            <ul>
              <li className="links">
                <Link to="/" onClick={() => scrollFooter()}>
                  Home
                </Link>
              </li>
              <li className="links">
                <Link to="/about" onClick={() => scrollFooter()}>
                  About
                </Link>
              </li>
              <li className="links">
                <Link to="/study-in-uk" onClick={() => scrollFooter()}>
                  Study Abroad
                </Link>
              </li>
              <li className="links">
                <Link to="/ielts" onClick={() => scrollFooter()}>
                  Test Preparations
                </Link>
              </li>
              <li className="links">
                <Link to="/contact-us" onClick={() => scrollFooter()}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-12 col-sm-6 col-lg-2">
            <h1 className="title">Countries</h1>
            <ul>
              <li className="links">
                <Link to="/study-in-uk" onClick={() => scrollFooter()}>
                  Study in UK
                </Link>
              </li>
              <li className="links">
                <Link to="/study-in-australia" onClick={() => scrollFooter()}>
                  Study in Australia
                </Link>
              </li>
              <li className="links">
                <Link to="/study-in-japan" onClick={() => scrollFooter()}>
                  Study in Japan
                </Link>
              </li>
              <li className="links">
                <Link to="/study-in-canada" onClick={() => scrollFooter()}>
                  Study in Canada
                </Link>
              </li>
              <li className="links">
                <Link to="/study-in-usa" onClick={() => scrollFooter()}>
                  Study in USA
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-12 col-sm-6 col-lg-4">
            <h1 className="title">Contact</h1>
            <p>
              EDUCRAFT EDUCATION NETWORK
              <br />
              4th Floor, Computer Bazaar,
              <br />
              Putalisadak, Kathmandu
            </p>
            <ul>
              <li>
                <a href="mailto:educrafteducationnetwork@gmail.com">
                  <i className="fa fa-envelope"></i>
                  &nbsp;educrafteducationnetwork@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:01-4500066">
                  <i className="fa fa-phone"></i>&nbsp;01-4500066
                </a>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <p className="text-center copyright-text">
          Copyright &copy; {new Date().getFullYear()} Educraft Education Network
        </p>
      </div>
    </footer>
  );
};

export default Footer;
